import type { HSTitleSetting, SandTableGroupSettings } from '@types';

export const MAX_SAND_TABLES = 500;

export const MAX_MARKERS = 500;

export const MARKER_SIZE = 24;
export const MARKER_IMAGE_SIZE = 30;
export const RADAR_SIZE = 114;

export const MARKER_ICON_DEFAULT = {
  fillColor: '40,110,250,1',
  borderColor: '255,255,255,1',
  activeFillColor: '250,100,0,1',
  activeBorderColor: '255,255,255,1',
};

export const IMG_RADAR =
  'https://ssl-static2.720static.com/imgs/marker-radar.408ffdbe1bd4f2a3a8df6526aee5acc5.png';

export const IMG_ANCHOR =
  'https:/ssl-static2.720static.com/imgs/img-anchor.286cdf788594471f5868cc0f5d0276ca.png';

export const MARKER_TITLE_DEFAULT: HSTitleSetting = {
  align: 'left',
  edge: 'top',
  ox: 0,
  oy: -10,
  font: {
    fontSize: 12,
    fontColor: '255,255,255,1',
  },
  background: {
    type: 0,
    bgColor: '0,0,0,0.5',
    bgRoundedge: 5,
    borderWidth: 0,
    borderColor: '0,0,0,0.5',
    gradientAngle: 0,
    gradientStartColor: '0,0,0,0.5',
    gradientEndColor: '0,0,0,0.5',
  },
  styleType: 0,
  writingMode: 0,
};

export const IMAGE_MARKER_TITLE_DEFAULT: HSTitleSetting = {
  align: 'left',
  edge: 'bottom',
  ox: 0,
  oy: -20,
  font: {
    fontSize: 12,
    fontColor: '255,255,255,1',
  },
  background: {
    bgColor: '0,0,0,0.5',
    bgRoundedge: 5,
    borderWidth: 0,
    borderColor: '0,0,0,0.5',
  },
};

export const LINE_ANIMATION_ICONS = [
  { url: '/hotspots/system/map/traffic/che1.png', width: 57, height: 95 },
  { url: '/hotspots/system/map/traffic/che2.png', width: 57, height: 95 },
  { url: '/hotspots/system/map/traffic/che3.png', width: 57, height: 95 },
  { url: '/hotspots/system/map/traffic/che4.png', width: 57, height: 95 },
  { url: '/hotspots/system/map/traffic/che5.png', width: 57, height: 95 },
  { url: '/hotspots/system/map/traffic/dongche.png', width: 57, height: 186 },
  { url: '/hotspots/system/map/traffic/feiji.png', width: 96, height: 105 },
  { url: '/hotspots/system/map/traffic/huoche.png', width: 57, height: 236 },
  {
    url: '/hotspots/system/map/traffic/lunchuan.png',
    width: 57,
    height: 222.5,
  },
];

export const SANDTABLE_GROUP_SETTINGS: Required<SandTableGroupSettings> = {
  type: 0,
  bgColor: '0,0,0,0.5',
  fontColor: '255,255,255,1',
  activeFontColor: '245,166,35,1',
};
